import type { FC } from 'react'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import Button from '@segment/matcha/components/Button'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import PropCardBase, * as PropCard from '@segment/matcha/recipes/PropCard'

import useMatchMedia from '@segment/utils/useMatchMedia'

import PersonalizationStrategiesImage from './PersonalizationStrategiesImage'

const data = {
  title: `9 Personalization strategies to try in 2021`,
  content: `Your customers deserve more than surface level personalization, so get your personalization off the ground with these tried and tested strategies.`,
  button: {
    title: `Download now`,
    href: `https://learn.segment.com/personalization-strategies-2021/`,
  },
}

const PersonalizationStrategies: FC = () => {
  const theme = useTheme()
  const mobileResolutionMediaQuery = theme.breakpoints.down(`xs`, false)
  const isMobileResolution = useMatchMedia(mobileResolutionMediaQuery, true)

  return (
    <SectionBase variant="noCopy" sticky={true}>
      <Section.Contents>
        <CardWrapper>
          <PropCardBase reverse={isMobileResolution}>
            <PropCard.Copy>
              <PropCard.Title>{data.title}</PropCard.Title>
              <PropCard.Text>{data.content}</PropCard.Text>
              <Button color="primary" href={data.button.href} size="large" variant="filled">
                {data.button.title}
              </Button>
            </PropCard.Copy>
            <PropCard.Img>
              <PersonalizationStrategiesImage alt={`Illustration: ${data.title}`} />
            </PropCard.Img>
          </PropCardBase>
        </CardWrapper>
      </Section.Contents>
    </SectionBase>
  )
}

const CardWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
`

export default PersonalizationStrategies
